import { Injectable, Output, EventEmitter, Directive } from '@angular/core';
import {AppSettings} from '../../settings/app-settings.model';

@Directive()
@Injectable()
export class HelpPanelCommunicationService {
    private helpContentUrl = '';

    @Output() helpLinkClicked$: EventEmitter<string>;
    @Output() closePanelClicked$: EventEmitter<string>;

    constructor(private settings: AppSettings) {
        this.helpLinkClicked$ = new EventEmitter<string>();
        this.closePanelClicked$ = new EventEmitter<string>();
    }

    emitHelpLinkClickEvent(link: string) {
        this.helpLinkClicked$.emit(this.settings.help.linkBaseUrl + link);
    }

    emitClosePanelEvent() {
        this.closePanelClicked$.emit(null);
    }

    emitPageLevelHelpClickEvent() {
        this.helpLinkClicked$.emit(this.helpContentUrl || (this.settings.help.linkBaseUrl + this.settings.help.defaultHelpContentPage));
    }

    setHelpContentUrl(newUrl: string) {
        this.helpContentUrl = this.settings.help.linkBaseUrl + newUrl;
    }

    getHelpContentUrl(): string {
        return this.helpContentUrl;
    }

    getProductVersion(): string {
        return this.settings.productVersion;
    }
}
